import { LinearGradient as ExpoLinearGradient } from "expo-linear-gradient";
import React from "react";

// Extend ExpoLinearGradient props but override colors to be more flexible
interface LinearGradientProps extends Omit<
  React.ComponentProps<typeof ExpoLinearGradient>,
  "colors"
> {
  // More flexible than readonly [string, string, ...string[]]
  colors: string[];
}

export function LinearGradient({ colors, ...props }: LinearGradientProps) {
  // Ensure at least 2 colors for gradient - duplicate single color if needed
  const gradientColors =
    colors.length < 2 ? [colors[0] || "#000000", colors[0] || "#000000"] : colors;

  return (
    <ExpoLinearGradient
      {...props}
      // Convert the type to confirm that we have at least two strings in the array
      colors={gradientColors as unknown as readonly [string, string, ...string[]]}
    />
  );
}
